import { styled } from "styled-components";

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 1.5rem 1.5rem;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & > hr {
    border-top: 1px solid ${({ theme }) => theme.colors.borderLowest};
  }
`;

const Faq = styled.div`
  cursor: pointer;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  & > span {
    color: ${({ theme }) => theme.colors.black};
    font-size: 1rem;
    font-weight: 600;
    line-height: 116%;
  }

  & > svg {
    flex-shrink: 0;
    transform: rotate(45deg);
  }
`;

const Back = styled.div`
  display: flex;

  & > svg {
    flex-shrink: 0;
    transform: rotate(225deg);
  }
`;

export default {
  Container,
  List,
  Faq,
  Back,
};
